<template>
    <div>用户协议正在协议中</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
